/**
 * @Author: wp 1683997498@qq.com
 * @Date: 2023-12-20 08:44:39
 * @LastEditors: wp 1683997498@qq.com
 * @LastEditTime: 2024-07-22 08:41:12
 * @FilePath: \twzc004-h5\src\main.js
 * @Description: 
 * @
 * @Copyright (c) 2024 by 广东天网智城科技有限公司, 保留所有权利。 
 */

import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import router from './router'
createApp(App).use(router).mount('#app')

// if ('serviceWorker' in navigator) {
//     window.addEventListener('load', () => {
//       navigator.serviceWorker.register('/service-worker.js')
//         .then(registration => {
//           console.log('ServiceWorker registration successful with scope: ', registration.scope);
//         })
//         .catch(error => {
//           console.log('ServiceWorker registration failed: ', error);
//         });
//     });
//   }

// //创建webworker

// if (window.Worker) {
//     const worker = new Worker('/worker.js');
  
//     worker.onmessage = function(event) {
//       if (event.data.success) {
//         console.log('Loaded URLs from worker:', event.data.urls);
//         event.data.urls.forEach(url => {
//           const videoElement = document.createElement('video');
//           videoElement.src = url;
//           videoElement.controls = true;
//           document.body.appendChild(videoElement);
//         });
//       } else {
//         console.error('Error from worker:', event.data.error);
//       }
//     };
  
//     worker.onerror = function(error) {
//       console.error('Worker error:', error);
//     };

//     const urls = [
//       'uploads/bg/video/app/2/wite_idle_02.mp4',
//       'uploads/bg/video/app/2/wite_idle_03.mp4',
//       'uploads/bg/video/app/2/wite_idle_05.mp4',
//       'uploads/bg/video/app/2/wite_idle_07.mp4',
//       'uploads/bg/video/app/2/wite_idle_10.mp4',
//       'uploads/bg/video/app/2/wite_idle_13.mp4',
//       'uploads/bg/video/app/2/wite_idle_15.mp4',
//       'uploads/bg/video/app/1/wite_idle_02.mp4',
//       'uploads/bg/video/app/1/wite_idle_03.mp4',
//       'uploads/bg/video/app/1/wite_idle_05.mp4',
//       'uploads/bg/video/app/1/wite_idle_07.mp4',
//       'uploads/bg/video/app/1/wite_idle_10.mp4',
//       'uploads/bg/video/app/1/wite_idle_13.mp4',
//       'uploads/bg/video/app/1/wite_idle_15.mp4'
//     ];
//     worker.postMessage(urls);
//   } else {
//     console.error('Web Workers are not supported in your browser.');
//   }
  